export default ['$rootScope', 'StateUtils', 'EventHub', ($rootScope, StateUtils, EventHub) => {
    $rootScope.$on('$stateChangeSuccess', (event, toState, params) => {
        const path = StateUtils.getTrackingUrl(toState, params);
        EventHub.publish('tracking', 'pageView', {
            path
        });
    });
}];